export const blackBackGround = "linear-gradient( rgba(10, 23, 30, 0.98) 100%, rgba(10, 23, 30, 0.98) 100%),url(\"/images/bgscreen.jpg\")";
export const mainBackGround = "linear-gradient( rgba(10, 23, 30, 0.7) 100%, rgba(10, 23, 30, 0.7) 100%),url('/images/modal/background.jpg')";
